import { clamp } from 'lodash-es';
import { PLAN_READINESS_LEVELS } from './constants';
import { getVariantColor } from './utils';
export default {
    name: 'ReadinessBar',
    props: {
        readinessLevel: {
            type: Object,
            required: true,
            validator: (value)=>Object.keys(PLAN_READINESS_LEVELS).includes(value.value)
        },
        score: {
            type: Number,
            required: true
        },
        ariaLabel: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        pillBgClass () {
            return getVariantColor(this.readinessLevel.variant);
        },
        pillStyle () {
            return {
                width: `${clamp(this.score, 0, 100)}%`,
                backgroundColor: this.pillBgClass
            };
        }
    }
};
